import {ref, watch} from 'vue';
import {SearchDisplayMode, SearchPreviewTarget} from '../header-menu.types';
import {useCurrentPage} from './useCurrentPage';

export function useSearchDisplayMode() {
    const {currentPage} = useCurrentPage();

    const isSearchComponentVisible = ref(window.isSearchComponentVisible);
    const searchDisplayMode = ref<SearchDisplayMode>(SearchDisplayMode.NONE);
    const searchPreviewTarget = ref<SearchPreviewTarget>('NONE');

    watch(
        currentPage,
        () => {
            if (currentPage.value) {
                searchDisplayMode.value = currentPage.value?.searchDisplayMode;
            } else {
                searchDisplayMode.value = isSearchComponentVisible.value ? SearchDisplayMode.FORM : SearchDisplayMode.NONE;
            }
        },
        {immediate: true},
    );

    function setSearchDisplayModeToForm(target: SearchPreviewTarget) {
        searchDisplayMode.value = SearchDisplayMode.FORM;
        searchPreviewTarget.value = target;
    }

    return {
        searchDisplayMode,
        searchPreviewTarget,
        setSearchDisplayModeToForm,
    };
}
